import { Button, TextField, InputAdornment, IconButton, Divider } from '@mui/material'
import { useState } from 'react'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import api from '../../services/api'
import { useSelector } from 'react-redux';
import RegisterAccess from '../../utils/registerAccess';
import BottonLetf from '../../utils/buttonLeft';
import MessageAlert from '../../messages/messageAlert';

export default function EditeSenha({ user, cancelEdite }) {
    const admin = useSelector(state => state.account.user);
    const [edite, setEdite] = useState(false)
    const [load, setLoad] = useState(false)
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [showOld, setShowOld] = useState(false)
    const [showNew, setShowNew] = useState(false)

    function HandleChange(e) { setEdite({ ...edite, [e.target.name]: e.target.value }) }

    async function editPassword() {
        setMessageSuccess('')
        setMessageError('')
        setLoad(true)

        api.patch('/auth/edit-password', { ...edite, "userId": user._id, 'adminId': admin._id ?? '', allowedEdit: true })
            .then(response => {
                setLoad(false)
                // setMessageSuccess(response.data.msg) // sucesso.!
                setMessageSuccess('Senha actualizada com sucesso!')
            }).catch(err => {
                setLoad(false)
                setMessageError(err.response.data.message)
            })
    }

    return (
        <>
            <RegisterAccess page={'editar senha admin'} />

            <div className="tw-max-w-sm tw-mx-auto tw-mt-6 tw-bg-white tw-rounded-2xl tw-shadow-md tw-overflow-hidden">

                {/* Cabeçalho */}
                <div className="tw-bg-[#85287e] tw-px-6 tw-py-5 tw-flex tw-flex-col tw-items-center tw-gap-2">
                    <div className="tw-bg-white/20 tw-rounded-full tw-p-3">
                        <LockOutlinedIcon sx={{ color: '#fff', fontSize: 28 }} />
                    </div>
                    <p className="tw-text-white tw-font-bold tw-text-lg tw-m-0">Alterar Senha</p>
                    <p className="tw-text-white/70 tw-text-xs tw-m-0">Preencha os campos abaixo para actualizar a senha</p>
                </div>

                <div className="tw-px-6 tw-py-5 tw-flex tw-flex-col tw-gap-4">

                    {messageSuccess && <MessageAlert type={'success'} message={messageSuccess} />}
                    {messageError && <MessageAlert type={'error'} message={messageError} />}

                    <TextField
                        type={showOld ? 'text' : 'password'}
                        label="Senha Actual"
                        fullWidth
                        size="small"
                        name="oldPassword"
                        variant="outlined"
                        onChange={HandleChange}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton size="small" onClick={() => setShowOld(p => !p)} edge="end">
                                        {showOld ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        type={showNew ? 'text' : 'password'}
                        label="Nova Senha"
                        fullWidth
                        size="small"
                        name="newPassword"
                        variant="outlined"
                        onChange={HandleChange}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton size="small" onClick={() => setShowNew(p => !p)} edge="end">
                                        {showNew ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <Divider />

                    <BottonLetf
                        title={'Guardar'}
                        funcao={editPassword}
                        // disabled={!edite?.newPassword || !edite?.oldPassword}
                        disabled={!edite?.newPassword}
                        load={load}
                    >
                        <Button onClick={() => cancelEdite(false)} color="error" size="small">voltar</Button>
                    </BottonLetf>
                </div>
            </div>
        </>
    )
}
